//Plantilla de archivo de store
const namespaced = true
import _ from 'lodash';
import api from '../../../api/catalogs/components.js';

const state = {
    components_catalogs: [],
    loading_components: false,
}
const mutations = {
    SET_COMPONENTS_CATALOGS(state, data) {
        state.components_catalogs = data;
    },
    SET_LOADING_COMPONENTS(state, data) {
        state.loading_components = data;
    },
    ADD_COMPONENT(state, value) {
        state.components_catalogs.push(value);
    },
    UPDATE_COMPONENT(state, value) {
        const newArr = _.clone(state.components_catalogs);
        const index = _.findIndex(state.components_catalogs, function (o) { return o.id == value.id });
        if (index !== -1) {
            newArr[index] = value;
        }
        state.components_catalogs = newArr
    },
    DELETE_COMPONENT(state, value) {
        // state.components_catalogs.splice(_.findIndex(state.components_catalogs, function (o) { return o.id == value }), 1); //Ese codigo si elimina el elemento del arreglo 
        state.components_catalogs.find(item => item.id === value.id).active = value.active;
    },
}
const actions = {
    getComponentsCatalog(context, data) {
        context.commit('SET_LOADING_COMPONENTS', true);
        return new Promise((resolve) => {
            api.getComponentsCatalog(data).then(function (res) {
                context.commit('SET_COMPONENTS_CATALOGS', res.data.data);
                resolve(res);
                context.commit('SET_LOADING_COMPONENTS', false);
                context.dispatch('notifications/add', { 'color': 'success', 'visibility': true, 'timeout': 5000, 'text': res.data.message }, { root: true });
            }).catch((e) => {
                context.dispatch('notifications/add', { 'color': 'error', 'visibility': true, 'timeout': 5000, 'text': e.messages }, { root: true });
                context.commit('SET_LOADING_COMPONENTS', false);
            })
        })
    },
    addComponent(context, data) {
        context.commit('SET_LOADING_COMPONENTS', true);
        return new Promise((resolve) => {
            api.addComponent(data).then(function (res) {
                context.commit('ADD_COMPONENT', res.data.data);
                resolve(res);
                context.commit('SET_LOADING_COMPONENTS', false);
                context.dispatch('notifications/add', { 'color': 'success', 'visibility': true, 'timeout': 5000, 'text': res.data.message }, { root: true });
            }).catch((e) => {
                context.dispatch('notifications/add', { 'color': 'error', 'visibility': true, 'timeout': 5000, 'text': e.messages }, { root: true });
                context.commit('SET_LOADING_COMPONENTS', false);
            })
        })
    },
    updateComponent(context, data) {
        context.commit('SET_LOADING_COMPONENTS', true);
        return new Promise((resolve) => {
            api.updateComponent(data.id, data.data).then(function (res) {
                context.commit('UPDATE_COMPONENT', res.data.data);
                resolve(res);
                context.commit('SET_LOADING_COMPONENTS', false);
                context.dispatch('notifications/add', { 'color': 'success', 'visibility': true, 'timeout': 5000, 'text': res.data.message }, { root: true });
            }).catch((e) => {
                context.dispatch('notifications/add', { 'color': 'error', 'visibility': true, 'timeout': 5000, 'text': e.messages }, { root: true });
                context.commit('SET_LOADING_COMPONENTS', false);
            })
        })
    },
    deleteComponent(context, id) {
        context.commit('SET_LOADING_COMPONENTS', true);
        return new Promise((resolve) => {
            api.deleteComponent(id).then(function (res) {
                context.commit('DELETE_COMPONENT', res.data.data);
                context.dispatch("notifications/add", { color: "success", visibility: true, timeout: 5000, text: res.data.message, }, { root: true });
                resolve(res.data);
                context.commit('SET_LOADING_COMPONENTS', false);
            }).catch(function (error) {
                console.log(error)
                context.commit('SET_LOADING_COMPONENTS', false);
            })
        })
    },
}

const getters = {
    getCatalogComponents(state) {
        return _.orderBy(state.components_catalogs, ['id'], ['desc'])
    },
}

export default {
    namespaced,
    state,
    mutations,
    actions,
    getters,
}